import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Billcolumn, PurchaseOrderColoum } from './purchaseReceivedColoum';
import Header from '../components/Header';
import PageLoader from '../../component/PageLoader';
import BillReceiveTable from '../components/BillReceiveTable';
import { getDate } from '../../utils/dateUtils';
import {
	generatePurchaseReceivePdf,
	getPurchaseReceiveDetails,
	updatePurchaseReceiveStatus,
} from '../../services/purchase_receive';
import NonPdfView from '../components/NonPdfView';
import ConfirmationModal from '../../component/modal/ConfirmationModal';
import Modal from '../../component/modal/Modal';
import { convertToBillColumn } from './purchaseReceivedColoum';
import Table from '../../component/table/Table';
import Button from '../../component/ui/Button';
import 'pdfmake/build/vfs_fonts';
import ProductDetailsDrawer from '../components/ProductDetailsDrawer';
import VendorDetailsDrawer from '../purchaseOrder/components/VendorDetailsDrawer';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/controller';

const ConvertToBill = [
	{
		'PURCHASE ORDER#': 'PO-0012',
		'ORDER DATE': '29/03/2024',
		STATUS: 'Issued',
	},
];

const PurchaseReceiveDetails = () => {
	const [isConvetToBillOpen, setIsConvertToBillOpen] = useState(false);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [isSavePR, setIsSavePR] = useState(false);
	const [productDetails, setProductDetails] = useState(null);
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
	const [isRestrictDeletePR, setIsRestrictDeletePR] = useState(false);
	const [loader, setLoader] = useState(false);
	const [purchaseReceiveDetails, setPurchaseReceiveDetails] = useState(null);
	const printPdfRef = useRef(null);
	const [vendorDetailsDrawerActiveOpenTab, setVendorDetailsDrawerActiveOpenTab] = useState('');
	const [isVendorDetailsDrawerOpen, setIsVendorDetailsDrawerOpen] = useState(false);

	async function handleDeletePurchaseReceive() {
		if (purchaseReceiveDetails.is_billed === 1) {
			setIsRestrictDeletePR(true);
		} else {
			try {
				setIsDeleteModalOpen(true);
			} catch (error) {
				toast.error('Something went wrong!');
			}
		}
	}

	const handleConfirmSave = async () => {
		try {
			const body = {
				purchase_receive_id: id,
				status: 'status',
				value: 1,
			};
			const response = await updatePurchaseReceiveStatus(body);
			if (response?.success === false) {
				throw new Error(response?.message || 'Failed to save Purchase Receive!');
			}
			toast.success('Purchase Receive saved successfully.');
			setIsSavePR(false);
			navigate(`/user/${suburl}/purchases-receive`);
		} catch (error) {
			toast.error(error.message || 'Failed to save Purchase Receive!');
		}
	};

	const handleConfirmDelete = async () => {
		try {
			const body = {
				purchase_receive_id: id,
				status: 'is_deleted',
				value: true,
			};
			await updatePurchaseReceiveStatus(body);
			toast.success('Purchase Receive deleted successfully.');
			setIsDeleteModalOpen(false);
			navigate(`/user/${suburl}/purchases-receive`);
		} catch (error) {
			toast.error('Failed to delete Purchase Receive!');
		}
	};

	const handleCancelDelete = () => {
		setIsDeleteModalOpen(false);
	};

	async function handlePRPrintAndDownloadPdf(type = 'print') {
		try {
			setLoader(true);
			const pdf_details = await generatePurchaseReceivePdf(id);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_receive_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoader(false);
		}
	}

	async function handleFetchPurchaseReceiveDetails() {
		try {
			const { purchaseReceive } = await getPurchaseReceiveDetails(Number(id));
			setPurchaseReceiveDetails(purchaseReceive);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	useEffect(() => {
		if (id) {
			handleFetchPurchaseReceiveDetails();
		}
	}, [id]);

	useEffect(() => {
		if (purchaseReceiveDetails) {
			document.title = `${purchaseReceiveDetails.purchase_receive_number ||
				'PR-' + purchaseReceiveDetails.purchase_receive_id
				} | Purchase Receive Details | Pharmnex`;
		}
	}, [purchaseReceiveDetails]);

	return (
		<div
			style={{
				backgroundColor: '#EDEDF7',
				height: '100%',
				overflowY: 'auto',
			}}
		>
			<div className="px-2">
				<Header
					headerTitle="Purchase Receive Details"
					closeButton={{
						showCloseButton: true,
						handler: () => navigate(-1),
					}}
					buttons={[
						...(purchaseReceiveDetails && purchaseReceiveDetails?.status === 0
							? [
								{
									id: 1,
									className: 'btn-gray mt-0 px-4',
									disabled: !hasPermission(
										'purchases.purchase_receives.edit',
										user?.role?.role_permissions,
									),
									button: 'Edit',
									handler: () => navigate(`/user/${suburl}/purchases-receive-create/pr-${id}`),
								},
							]
							: []),
						{
							id: 2,
							className: 'btn-gray mt-0',
							disabled: !hasPermission(
								'purchases.purchase_receives.communications_email',
								user?.role?.role_permissions,
							),
							button: 'Send Email',
							handler: () => navigate(`/user/${suburl}/purchases-receive-send-emails/${id}`),
						},
						{
							id: 3,
							className: 'mt-0 btn-gray add-pro',
							disabled: !hasPermission(
								'purchases.purchase_receives.download_print_pdf',
								user?.role?.role_permissions,
							),
							button: 'PDF/Print',
							loader: loader,
							handler: async () => {
								handlePRPrintAndDownloadPdf();
							},
						},
						...(purchaseReceiveDetails &&
							purchaseReceiveDetails?.status !== 0 &&
							purchaseReceiveDetails?.is_billed !== 1
							? [
								{
									id: 4,
									className: 'btn-gray add-pro',
									disabled: !hasPermission(
										'purchases.purchase_bills.create',
										user?.role?.role_permissions,
									),
									button: 'Convert To Bill',
									handler: () => navigate(`/user/${suburl}/purchases-bills-create/pr-${id}`),
								},
							]
							: []),
						...(purchaseReceiveDetails && purchaseReceiveDetails?.status === 0
							? [
								{
									id: 6,
									className: 'mt-0 btn-gray add-pro',
									disabled: !hasPermission(
										'purchases.purchase_receives.create',
										user?.role?.role_permissions,
									),
									button: 'Save',
									handler: () => setIsSavePR(true),
								},
							]
							: []),
						{
							id: 7,
							className: 'btn-gray add-pro',
							disabled: !hasPermission(
								'purchases.purchase_receives.delete',
								user?.role?.role_permissions,
							),
							button: 'Delete',
							handler: handleDeletePurchaseReceive,
						},
					]}
				/>
			</div>

			{!purchaseReceiveDetails ? (
				<PageLoader />
			) : (
				<div>
					<BillReceiveTable
						height={'83.5px'}
						tableConfig={{
							billTable: {
								title: 'Bills',
								column: Billcolumn,
								row:
									purchaseReceiveDetails?.purchase_bill?.length > 0
										? purchaseReceiveDetails?.purchase_bill?.map((pb) => {
											const formattedBillDate = new Date(pb?.bill_date).toLocaleDateString(
												'en-GB',
											);
											const formattedDueDate = new Date(pb?.due_date).toLocaleDateString('en-GB');

											const status =
												pb?.status === 0
													? 'N / A'
													: pb?.status === 1
														? 'Open'
														: pb?.status === 2
															? 'Partially Paid'
															: 'Closed';

											return {
												id: pb?.purchase_bill_id,
												'BILL#': pb?.bill_number,
												DATE: formattedBillDate,
												STATUS: status,
												'DUE DATE': formattedDueDate,
												AMOUNT: pb?.bill_amount,
												'BALANCE DUE': pb?.due_amount,
											};
										})
										: [],
								count: purchaseReceiveDetails?.purchase_bill.length,
								onRowClick: (id) => {
									if (id) {
										navigate(`/user/${suburl}/purchases-bills-details/${id}`);
									}
								},
							},
							receiveTable: {
								title: 'Purchase Order',
								column: PurchaseOrderColoum,
								row: purchaseReceiveDetails.purchase_order
									? [purchaseReceiveDetails.purchase_order].map((po) => {
										return {
											id: po.purchase_order_id,
											DATE: getDate(po?.date),
											'PO#': JSON.stringify({
												po_number: po?.purchase_order_number,
												is_draft: po?.is_draft,
											}),
											'VENDOR NAME': purchaseReceiveDetails?.vendor?.vendor_name,
											STATUS: po?.status || 'N/A',
											RECEIVED: JSON.stringify({
												is_received: po.is_received,
												is_partially_received: po.is_partially_received,
												status: po?.status,
											}),
											BILLED: JSON.stringify({
												is_billed: po?.is_billed,
												is_partially_billed: po?.is_partially_billed,
											}),
											'Expected By':
												po?.expected_delivery_date === null
													? 'N/A'
													: getDate(po?.expected_delivery_date),
										};
									})
									: [],
								count: purchaseReceiveDetails.purchase_order ? 1 : 0,
								onRowClick: (id) => {
									if (id) {
										navigate(`/user/${suburl}/purchases-order-details/${id}`);
									}
								},
							},
						}}
					/>

					<NonPdfView
						isPurchaseReceive={true}
						orderStatus={false}
						printPdfRef={printPdfRef}
						isShowProductDiscardButton={false}
						handleProductDetails={(product) => {
							setProductDetails(product);
							setIsSidebarOpen(true);
						}}
						setVendorDetailsDrawerActiveOpenTab={setVendorDetailsDrawerActiveOpenTab}
						setIsVendorDetailsDrawerOpen={setIsVendorDetailsDrawerOpen}
						handleDiscardQuantity={() => { }}
						purchaseOrderDetails={{
							...purchaseReceiveDetails?.purchase_order,
							vendor_name: purchaseReceiveDetails.vendor.vendor_name,
							purchase_order_number:
								purchaseReceiveDetails.purchase_receive_number ||
								'PR-' + purchaseReceiveDetails.purchase_receive_id,
							purchase_order_products: purchaseReceiveDetails.purchase_receive_products,
							expected_delivery_date: purchaseReceiveDetails?.receive_date,
							is_billed: purchaseReceiveDetails?.is_billed,
							is_received: purchaseReceiveDetails?.status,
							is_partially_billed: purchaseReceiveDetails?.is_partially_billed,
							is_draft: purchaseReceiveDetails?.status === 0 ? 1 : 0,
							delivery_address: purchaseReceiveDetails?.delivery_address,
							...(purchaseReceiveDetails?.status === 0 ? { status: 'Draft' } : {}),
						}}
					/>
				</div>
			)}

			{isConvetToBillOpen && (
				<Modal
					className="convertToBillModal"
					isOpen={isConvetToBillOpen}
					onClose={setIsConvertToBillOpen}
					cancelButton={setIsConvertToBillOpen}
					title={
						<div
							style={{
								fontWeight: '600',
								color: '#000000',
								fontSize: '22px',
								paddingTop: '10px',
							}}
						>
							Purchase Receive ({purchaseReceiveDetails?.purchase_receive_number})
						</div>
					}
					headerClassName="custom-header"
					bodyClassName="convertToBillBody"
				>
					<div style={{ backgroundColor: '#E6F5FF', height: '36px', marginBottom: '36px' }}>
						<p
							style={{
								fontSize: '18px',
								color: '#555B67',
								paddingLeft: '10px',
								paddingTop: '3px',
								marginTop: '8px',
							}}
						>
							Note: You can create a bill for either Yet to Receive items or Received Items.
						</p>
					</div>

					<div>
						<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<input
									type="radio"
									id="yetToReceive"
									name="status"
									value="yetToReceive"
									style={{ marginBottom: '21px', width: '16px', height: '23px' }}
								/>
								<label
									htmlFor="yetToReceive"
									style={{ marginLeft: 5 }}
								>
									<div style={{ margin: 0, color: '#555B67', fontSize: '16px' }}>
										Yet to Receive
									</div>
									<div style={{ margin: 0, color: '#9FA6B5', fontSize: '16px' }}>
										Yet to receive product in this PO
									</div>
								</label>
							</div>

							<div style={{ display: 'flex', alignItems: 'center', marginLeft: '104px' }}>
								<input
									type="radio"
									id="received"
									name="status"
									value="received"
									style={{ marginBottom: '19px', width: '16px', height: '23px' }}
								/>
								<label
									htmlFor="received"
									style={{ marginLeft: 5 }}
								>
									<div style={{ margin: 0, color: '#555B67', fontSize: '16px' }}>Received</div>
									<div style={{ margin: 0, color: '#9FA6B5', fontSize: '16px' }}>
										Received product in this PO
									</div>
								</label>
							</div>
						</div>

						<div
							style={{
								marginTop: '20px',
								maxHeight: '85px',
								overflowY: 'hidden',
								width: '626px',
							}}
						>
							<Table
								coloum={convertToBillColumn}
								row={ConvertToBill}
								onRowClick={() => { }}
							/>
						</div>

						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'end',
								gap: 4,
								marginTop: '60px',
							}}
						>
							<Button
								type="button"
								className="mt-0 btn-gray add-pro "
								button="Cancel"
							/>
							<Button
								type="button"
								className="mt-0 btn-primary add-pro"
								button="Convert To Bill"
							/>
						</div>
					</div>
				</Modal>
			)}

			<ConfirmationModal
				isOpen={isDeleteModalOpen}
				onCancel={handleCancelDelete}
				onOk={handleConfirmDelete}
				title="Confirm Deletion"
				content={
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '500',
							color: 'black',
						}}
					>
						Are you sure you want to delete{' '}
						<span style={{ fontWeight: '600' }}>
							{purchaseReceiveDetails?.purchase_receive_number || 'this purchase receive'}
						</span>
						?
					</p>
				}
			/>
			<ConfirmationModal
				isOpen={isSavePR}
				onCancel={() => setIsSavePR(false)}
				onOk={handleConfirmSave}
				title="Confirmation Save Purchase Receive"
				content={
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '500',
							color: 'black',
						}}
					>
						Are you sure you want to save purchase receive?
					</p>
				}
			/>

			{isRestrictDeletePR && (
				<Modal
					className="deleteVendorsModal"
					title="Change Status PO"
					isOpen={isRestrictDeletePR}
					onClose={() => {
						setIsRestrictDeletePR(false);
					}}
					cancelButton={() => {
						setIsRestrictDeletePR(false);
					}}
				>
					<p
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '10px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						{'Delete the associated Purchase Bill ' +
							purchaseReceiveDetails?.purchase_bill[0]?.bill_number +
							' before deleting the Purchase Receive.'}
					</p>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							className="mt-0 btn-gray add-pro"
							button="Cancel"
							onClick={() => {
								setIsRestrictDeletePR(false);
							}}
						/>

						<Button
							type="button"
							button={'Go to ' + purchaseReceiveDetails?.purchase_bill[0]?.bill_number}
							className="mt-0 px-4 btn-danger relative"
							disabled={
								!hasPermission('purchases.purchase_bills.view', user?.role?.role_permissions)
							}
							onClick={() =>
								navigate(
									`/user/${suburl}/purchases-bills-details/${purchaseReceiveDetails?.purchase_bill[0]?.purchase_bill_id}`,
								)
							}
						/>
					</div>
				</Modal>
			)}

			{/* Sidebar ka layout */}
			{isSidebarOpen && (
				<ProductDetailsDrawer
					id={productDetails?.product_id}
					vendor={{
						vendor_id: purchaseReceiveDetails?.vendor?.vendor_id,
						vendor_name: purchaseReceiveDetails?.vendor?.vendor_name,
					}}
					setIsSidebarOpen={setIsSidebarOpen}
				/>
			)}
			{isVendorDetailsDrawerOpen && (
				<VendorDetailsDrawer
					isOpen={isVendorDetailsDrawerOpen}
					onClose={() => setIsVendorDetailsDrawerOpen(false)}
					vendor_id={purchaseReceiveDetails?.vendor?.vendor_id}
					vendorDetailsDrawerActiveOpenTab={vendorDetailsDrawerActiveOpenTab}
				/>
			)}
		</div>
	);
};

export default PurchaseReceiveDetails;
